import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {Validator} from 'vee-validate'
export default {
  data: function() {
    return {
        file: '',
        error_message: '',
        success_message: '',
        error_seen: false,
        success_seen: false,
        //test:"netraj",
      }
    },
    created: function() {
    },
    mounted() {
    },
    methods: {
      submitFile(){
        var formData = new FormData();
        formData.append('csv', this.file);
        axios.post( apiUrl.api_url + 'csv_load',
          formData,
          {
            headers:
            {
                'Content-Type': 'multipart/form-data'
            }
          })
        .then((response) => {
          response = response.data;
          //console.log(response.data.data);
          if(response.status == true)
          {
            console.log(response.data.numrows);
            this.error_seen = false,
            this.success_seen = true,
            this.error_message = '';
            this.success_message = response.data.numrows+" items added successfully";
          }
          else
          {
            this.error_seen = true,
            this.success_seen = false,
            console.log(response.message);
            this.error_message = response.message;
            this.success_message = '';
          }
          console.log(response);
          console.log('SUCCESS!!');
        })
        .catch(function(){
          this.error_seen = true,
          this.success_seen = false,
          this.error_message = "File caanot be uploaded";
          this.success_message = '';
          console.log('FAILURE!!');
        });
      },
      handleFileUpload(){
        this.file = this.$refs.file.files[0];
      }
    }
  }



// WEBPACK FOOTER //
// ./src/views/components/import/import.component.js